import { Link } from "react-router-dom";
import { Footer } from "../components/Footer";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 py-10">
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="text-center">
          <h1 className="text-5xl font-bold text-ink">404</h1>
          <p className="mt-3 text-sm text-smoke">Cette page n'existe pas.</p>
          <Link to="/home" className="btn-primary mt-6">
            Revenir à l'accueil
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
